/**
 * @file 兼容多币的文案展示 - 币全放左边，数全放右边版
 */
import cls from 'classnames';
import { formatPrecision } from '@/utils/num';

import styles from './index.module.scss';
import { appPath } from '@web3/base-utils';

interface Props {
  data: {
    url?: string;
    symbol: string;
    amount: string;
  }[];
  className?: string;
  iconClassName?: string;
}

export const MultiIcon = (props: Props) => {
  const { data, className, iconClassName } = props;
  return (
    <div className={cls(styles.container, className)}>
      <div className={styles.iconList}>
        {data.map((item, index) => {
          return (
            <img
              className={cls(styles.icon, iconClassName, {
                [styles.moreIcons]: index > 0,
              })}
              src={item.url || `${appPath}/svg/home/icon-backup.svg`}
              alt=""
              key={index}
            />
          );
        })}
      </div>
      <div className={styles.amount}>
        {data
          .map((item) => `${formatPrecision(item.amount)} ${item.symbol}`)
          .join(' + ')}
      </div>
    </div>
  );
};
